import { Trans } from "@coworker/locales";
import BasicWidget from "@coworker/components/src/components/BasicWidget";

import { describeAreaFilter } from "../../InputPopup/UserFiltersRow/filterChoices";

import Location from "../../../assets/svg/location.svg?react";
import { useMfaqFilters } from "../../MFAQ/hooks/useMfaqFilters";
import {
  DEFUALT_PERIOD_VALUE,
  PERIOD_ID,
} from "../../MFAQ/hooks/usePeriodFilter";
import {
  DEFUALT_LOCATION_VALUE,
  LOCATION_ID,
} from "../../MFAQ/hooks/useLocationFilter";
import { useMemo } from "react";
import { getSelectedFilterValue } from "@coworker/apprestructured/src/shared/filters/utils/filter/filtervalue";

export function TaskFormMfaqArea({ area }) {
  const mfaqFilters = useMfaqFilters({ hideQuestionsWithTasksOnly: false });

  const period = getSelectedFilterValue(
    PERIOD_ID,
    mfaqFilters.filterValues,
    DEFUALT_PERIOD_VALUE
  ).value;

  const location = getSelectedFilterValue(
    LOCATION_ID,
    mfaqFilters.filterValues,
    DEFUALT_LOCATION_VALUE
  ).value;

  const filters = useMemo(() => {
    return [period, location];
  }, [period, location]);

  const isPickupOrComplete = area;
  const areaForQuestion = describeAreaFilter(isPickupOrComplete ?? filters);

  return (
    <BasicWidget
      testId="task-creation-mfaq-area"
      title={areaForQuestion}
      text={!isPickupOrComplete && <Trans>questionsAskedString</Trans>}
      icon={isPickupOrComplete && <Location />}
    />
  );
}
